import {createAction, props} from '@ngrx/store';
import VideoClipModel from '../../../../../models/video-clip.model';
import {VideoStateEnum} from '../../../../../enums/video-state.enum';
import OverlayModel from '../../../../../models/overlay.model';
import FormModel from '../../../../../models/form.model';
import {ErrorEnum} from '../../../../../enums/error.enum';

export const GetVideoAction = createAction('[Video] - Get Video');
export const BeginGetVideoAction = createAction('[Video] - Begin Get Video',
    props<{ videoId: string, params: Map<string, string> }>());

// The props method is used to define any additional payload.
// Action creators provide a consistent and type-safe way to create an action

export const SuccessGetVideoAction = createAction('[Video] - Success Get Video',
    props<{ payload, startState: VideoStateEnum }>());

export const BeginUpdateVideoTimeAction = createAction('[Video] - Begin Video Time Update',
    props<{ payload: { currentTime: number, currentSceneId: number } }>());

export const UpdateVideoTimeAction = createAction('[Video] - Video Time Update',
    props<{ currentTime: number }>());

export const UpdateVideoMasterVolumeAction = createAction('[Video] - Master Volume Update',
    props<{ currentVolume: number }>());

export const UpdateCurrentFrameAction = createAction('[Video] - Video Frame Update',
    props<{ currentFrame: number }>());

export const SetInitialVideoValues = createAction('[Video] - Set Current Scene',
    props<{ currentScene: VideoClipModel, overlays?: Array<OverlayModel>, forms?: Array<FormModel> }>());

export const SetIsCurrentSceneLoaded = createAction('[Video] - Set Is Current Scene Loaded',
    props<{ isCurrentSceneLoaded: boolean }>());

export const BeginSelectNextVideoSceneAction = createAction('[Video] - Begin Select Next Video Scene',
    props<{ payload: { currentSceneId: number } }>());

export const SetVideoStateTypeAction = createAction('[Video] - Set video state',
    props<{ videoState: VideoStateEnum }>());

export const VideoNavigateAction = createAction('[Video] - Jump in time',
    props<{ navigationTime: number, videoState: VideoStateEnum }>());

export const JumpToSceneAction = createAction('[Video] - Jump to scene action',
    props<{ navigationTime: number, videoState: VideoStateEnum }>());

export const ChangeClipByTimeAction = createAction('[Video] - Change Clip by Time',
    props<{ navigationTime: number }>());

export const UpdateNavigateTimeAction = createAction('[Video] - Time To Jump Update',
    props<{ navigationTime: number }>());

export const SetStartSceneTimeAction = createAction('[Video] - Set Start Scene Time',
    props<{ startSceneTime: number }>());

export const SetTotalTimeAction = createAction('[Video] - Set Total Time',
    props<{ totalTime: number }>());

export const ReplayVideoAction = createAction('[Video] - Replay Video');

export const ChangeSpaceKeyListenerAction = createAction('[Video] - Set Space Key Ability',
    props<{ isSpaceKeyListenerOn: boolean }>());

export const SetImagesPreloadedAction = createAction('[Video] - Set images state as preloaded',
    props<{ imagesPreloaded: boolean }>());

export const ErrorVideoAction = createAction('[Video] - Error', props<{ errorType: ErrorEnum | null, error: any }>());

export const GoForwardAction = createAction('[Video] - Go Forward Action');

export const GoBackwardAction = createAction('[Video] - Go Backward Action');

export const SetIsInMobilePreviewMode = createAction('[Video] - Set is in mobile preview mode',
    props<{ isInMobilePreviewMode: boolean }>());

export const SetIsInPreviewModeAction = createAction('[Video] - Set is in preview mode Action',
    props<{ preview: boolean }>());

export const VideoEndedAction = createAction('[Video] - Video Ended Action');

export const EmptyAction = createAction('[Video] - Empty Action');

export const SetIsIOSFullScreenDisable = createAction('[Video] - Set is iOS full-screen mode disable',
    props<{ isIOSFullScreenDisable: boolean }>());

export const UpdateForms = createAction('[Video] - Update forms', props<{ forms: FormModel[] }>());

export const UpdateForm = createAction('[Video] - Update form', props<{ form: FormModel }>());
